import { useState, useRef, useEffect } from "react";

// ── DESIGN TOKENS ──────────────────────────────────────────────────────────
const R = "#c0392b";
const NAVY = "#0f172a";
const NAVY2 = "#1e293b";
const MUTED = "#64748b";
const BORDER = "#e2e8f0";
const BG = "#f1f5f9";
const WHITE = "#ffffff";
const GREEN = "#16a34a";
const AMBER = "#d97706";
const BLUE = "#2563eb";

// ── MOCK DATA ──────────────────────────────────────────────────────────────
const USER = { name: "Manoj Shah", company: "Rallis India Ltd", mobile: "9820012345", email: "manoj.shah@rallis.co.in", kam: "Mohit Pandey", kam_phone: "9820099001", credit_limit: 2000000, credit_used: 1422500 };

const SHIPMENTS = [
  { cn: "CN-2026-4521", lr: "LR-D-88991", from: "Delhi", to: "Mumbai", consignee: "Rallis Mumbai Depot", pkgs: 240, weight: "6,200 kg", booked: "2026-04-04", status: "In Transit", eta: "2026-04-07", vehicle: "DL01AB1234", driver: "Rajan Kumar", route_pct: 68, material: "Agrochemicals", invoice: "INV-RAL-8821" },
  { cn: "CN-2026-4418", lr: "LR-D-88840", from: "Mumbai", to: "Chennai", consignee: "Rallis Chennai Store", pkgs: 180, weight: "4,800 kg", booked: "2026-03-30", status: "Delivered", eta: "2026-04-03", vehicle: "MH04CD5678", driver: "Suresh Nair", route_pct: 100, material: "Pesticides", invoice: "INV-RAL-8790", delivered: "2026-04-03 14:22", pod: true },
  { cn: "CN-2026-4390", lr: "LR-D-88812", from: "Pune", to: "Ahmedabad", consignee: "Rallis Ahmedabad", pkgs: 96, weight: "2,400 kg", booked: "2026-03-28", status: "Out for Delivery", eta: "2026-04-06", vehicle: "MH14GH9012", driver: "Vijay Patil", route_pct: 92, material: "Fungicides", invoice: "INV-RAL-8768" },
  { cn: "CN-2026-4312", lr: "LR-D-88734", from: "Delhi", to: "Kolkata", consignee: "Rallis East India", pkgs: 320, weight: "8,100 kg", booked: "2026-03-25", status: "Delivered", eta: "2026-03-30", vehicle: "WB02EF3456", driver: "Arun Das", route_pct: 100, material: "Herbicides", invoice: "INV-RAL-8712", delivered: "2026-03-30 11:45", pod: true },
  { cn: "CN-2026-4298", lr: "LR-D-88720", from: "Mumbai", to: "Nagpur", consignee: "Rallis Nagpur", pkgs: 120, weight: "3,200 kg", booked: "2026-04-06", status: "Booked", eta: "2026-04-08", vehicle: null, driver: null, route_pct: 0, material: "Agrochemicals", invoice: "INV-RAL-8860" },
];

const INVOICES = [
  { inv: "INV-2026-0892", cn: "CN-2026-4312", date: "2026-02-20", due: "2026-03-22", amount: 284500, paid: 0, aging: 45, status: "Overdue" },
  { inv: "INV-2026-0845", cn: "CN-2026-4298", date: "2026-03-05", due: "2026-04-04", amount: 192000, paid: 0, aging: 32, status: "Overdue" },
  { inv: "INV-2026-0801", cn: "CN-2026-4390", date: "2026-03-19", due: "2026-04-18", amount: 345000, paid: 0, aging: 18, status: "Due Soon" },
  { inv: "INV-2026-0756", cn: "CN-2026-4418", date: "2026-03-30", due: "2026-04-29", amount: 412000, paid: 0, aging: 7, status: "Current" },
  { inv: "INV-2026-0723", cn: "CN-2026-4521", date: "2026-04-05", due: "2026-05-05", amount: 189000, paid: 0, aging: 1, status: "Current" },
];

const UNBILLED = [
  { cn: "CN-2026-4521", lr: "LR-D-88991", route: "Delhi → Mumbai", date: "2026-04-04", pkgs: 240, weight: "6,200 kg", material: "Agrochemicals", days: 2 },
  { cn: "CN-2026-4298", lr: "LR-D-88720", route: "Mumbai → Nagpur", date: "2026-04-06", pkgs: 120, weight: "3,200 kg", material: "Agrochemicals", days: 0 },
  { cn: "CN-2026-4201", lr: "LR-D-88621", route: "Pune → Bangalore", date: "2026-04-01", pkgs: 80, weight: "2,100 kg", material: "Seeds", days: 5 },
  { cn: "CN-2026-4188", lr: "LR-D-88608", route: "Delhi → Hyderabad", date: "2026-03-29", pkgs: 160, weight: "4,400 kg", material: "Pesticides", days: 8 },
];

const GRIEVANCES = [
  { id: "GRV-2026-0045", cn: "CN-2026-4312", type: "Damage / Shortage", subject: "Partial damage to 12 bags of fungicide reported at Kolkata delivery", raised: "2026-04-01", status: "In Progress", priority: "High", sla_hours: 48, elapsed_hours: 22, assigned: "Kapil Agarwal", updates: [{ time: "2026-04-01 10:30", msg: "Ticket raised. Assigned to Kapil Agarwal." }, { time: "2026-04-02 14:00", msg: "Driver statement collected. Photos received. Insurance claim initiated." }, { time: "2026-04-03 09:00", msg: "Claim under review. BRL surveyor scheduled for Apr 7." }] },
  { id: "GRV-2026-0039", cn: "CN-2026-4201", type: "Transit Delay", subject: "Consignment delayed by 3 days on Pune-Bangalore route", raised: "2026-03-22", status: "Resolved", priority: "Medium", sla_hours: 24, elapsed_hours: 18, assigned: "Mohit Pandey", updates: [{ time: "2026-03-22 11:00", msg: "Delay reported. Vehicle breakdown on NH48." }, { time: "2026-03-23 16:00", msg: "Replacement vehicle deployed. Shipment resumed." }, { time: "2026-03-25 09:30", msg: "Delivered. Delay compensation credit note issued." }] },
  { id: "GRV-2026-0031", cn: "CN-2026-4188", type: "Invoice Dispute", subject: "Extra charges of ₹8,400 billed - not agreed in rate contract", raised: "2026-03-15", status: "Resolved", priority: "Low", sla_hours: 72, elapsed_hours: 48, assigned: "Bhimsen Sharma", updates: [{ time: "2026-03-15 14:00", msg: "Dispute raised. Rate contract shared." }, { time: "2026-03-17 11:00", msg: "Credit note issued for ₹8,400." }] },
];

const LEDGER = [
  { date: "2026-04-05", ref: "INV-2026-0723", type: "Invoice", debit: 189000, credit: 0, balance: 1422500 },
  { date: "2026-04-01", ref: "GRV-0039 CN", type: "Credit Note", debit: 0, credit: 8400, balance: 1233500 },
  { date: "2026-03-30", ref: "INV-2026-0756", type: "Invoice", debit: 412000, credit: 0, balance: 1241900 },
  { date: "2026-03-25", ref: "PYMT-0398", type: "Payment", debit: 0, credit: 500000, balance: 829900 },
  { date: "2026-03-19", ref: "INV-2026-0801", type: "Invoice", debit: 345000, credit: 0, balance: 1329900 },
  { date: "2026-03-10", ref: "PYMT-0372", type: "Payment", debit: 0, credit: 250000, balance: 984900 },
  { date: "2026-03-05", ref: "INV-2026-0845", type: "Invoice", debit: 192000, credit: 0, balance: 1234900 },
];

const STATUS_COLORS = {
  "In Transit": { bg: "#dbeafe", color: "#1d4ed8" },
  "Out for Delivery": { bg: "#fef3c7", color: "#92400e" },
  "Delivered": { bg: "#dcfce7", color: "#166534" },
  "Booked": { bg: "#f3e8ff", color: "#6b21a8" },
  "Overdue": { bg: "#fee2e2", color: "#991b1b" },
  "Due Soon": { bg: "#fef3c7", color: "#92400e" },
  "Current": { bg: "#dcfce7", color: "#166534" },
  "Open": { bg: "#fee2e2", color: "#991b1b" },
  "In Progress": { bg: "#fef3c7", color: "#92400e" },
  "Resolved": { bg: "#dcfce7", color: "#166534" },
  "High": { bg: "#fee2e2", color: "#991b1b" },
  "Medium": { bg: "#fef3c7", color: "#92400e" },
  "Low": { bg: "#dcfce7", color: "#166534" },
};

// ── SMALL COMPONENTS ───────────────────────────────────────────────────────
const Badge = ({ label, status }) => {
  const c = STATUS_COLORS[status || label] || { bg: "#f1f5f9", color: "#475569" };
  return <span style={{ background: c.bg, color: c.color, padding: "3px 10px", borderRadius: 20, fontSize: 11, fontWeight: 700, letterSpacing: 0.2, whiteSpace: "nowrap" }}>{label}</span>;
};

const Btn = ({ children, variant = "primary", onClick, full, size = "md", disabled }) => {
  const v = {
    primary: { bg: R, color: WHITE, border: "none" },
    secondary: { bg: WHITE, color: NAVY2, border: `1px solid ${BORDER}` },
    ghost: { bg: "transparent", color: R, border: `1.5px solid ${R}` },
    danger: { bg: "#fee2e2", color: "#991b1b", border: "none" },
    success: { bg: "#dcfce7", color: "#166534", border: "none" },
  }[variant];
  const p = size === "sm" ? "5px 14px" : size === "lg" ? "11px 28px" : "8px 20px";
  return <button disabled={disabled} onClick={onClick} style={{ ...v, padding: p, borderRadius: 8, fontSize: size === "sm" ? 12 : 13, fontWeight: 600, cursor: disabled ? "not-allowed" : "pointer", opacity: disabled ? 0.5 : 1, fontFamily: "inherit", width: full ? "100%" : "auto", transition: "all 0.15s", whiteSpace: "nowrap" }}
    onMouseEnter={e => !disabled && (e.currentTarget.style.opacity = "0.88")}
    onMouseLeave={e => !disabled && (e.currentTarget.style.opacity = "1")}>{children}</button>;
};

const Card = ({ children, style = {} }) => (
  <div style={{ background: WHITE, borderRadius: 14, border: `1px solid ${BORDER}`, padding: 20, ...style }}>{children}</div>
);

const SectionTitle = ({ title, sub, action }) => (
  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-end", marginBottom: 18 }}>
    <div>
      <h2 style={{ margin: 0, fontSize: 17, fontWeight: 700, color: NAVY }}>{title}</h2>
      {sub && <p style={{ margin: "3px 0 0", fontSize: 13, color: MUTED }}>{sub}</p>}
    </div>
    {action}
  </div>
);

const KpiCard = ({ label, value, sub, icon, accent }) => (
  <Card style={{ padding: "18px 20px" }}>
    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 10 }}>
      <span style={{ fontSize: 11, fontWeight: 700, color: MUTED, textTransform: "uppercase", letterSpacing: 0.8 }}>{label}</span>
      <span style={{ fontSize: 22, lineHeight: 1 }}>{icon}</span>
    </div>
    <div style={{ fontSize: 26, fontWeight: 800, color: accent || NAVY, fontFamily: "'DM Mono', monospace", lineHeight: 1.1 }}>{value}</div>
    {sub && <div style={{ fontSize: 12, color: MUTED, marginTop: 5 }}>{sub}</div>}
  </Card>
);

const ProgressBar = ({ pct, color = R, height = 6 }) => (
  <div style={{ background: "#f1f5f9", borderRadius: 99, height, overflow: "hidden" }}>
    <div style={{ background: color, height: "100%", width: `${pct}%`, borderRadius: 99, transition: "width 0.6s" }} />
  </div>
);

const Input = ({ label, placeholder, type = "text", value, onChange, required }) => (
  <div style={{ marginBottom: 14 }}>
    {label && <label style={{ fontSize: 12, fontWeight: 700, color: NAVY2, display: "block", marginBottom: 5, textTransform: "uppercase", letterSpacing: 0.5 }}>{label}{required && <span style={{ color: R }}> *</span>}</label>}
    <input type={type} value={value} onChange={onChange} placeholder={placeholder} style={{ width: "100%", padding: "9px 12px", border: `1.5px solid ${BORDER}`, borderRadius: 8, fontSize: 13, fontFamily: "inherit", outline: "none", boxSizing: "border-box", color: NAVY2 }} />
  </div>
);

const Sel = ({ label, children, required }) => (
  <div style={{ marginBottom: 14 }}>
    {label && <label style={{ fontSize: 12, fontWeight: 700, color: NAVY2, display: "block", marginBottom: 5, textTransform: "uppercase", letterSpacing: 0.5 }}>{label}{required && <span style={{ color: R }}> *</span>}</label>}
    <select style={{ width: "100%", padding: "9px 12px", border: `1.5px solid ${BORDER}`, borderRadius: 8, fontSize: 13, fontFamily: "inherit", outline: "none", color: NAVY2 }}>{children}</select>
  </div>
);

// ── LOGIN SCREEN ───────────────────────────────────────────────────────────
function LoginScreen({ onLogin }) {
  const [step, setStep] = useState(1);
  const [mobile, setMobile] = useState("");
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [sending, setSending] = useState(false);
  const [verifying, setVerifying] = useState(false);
  const [error, setError] = useState("");
  const refs = [useRef(), useRef(), useRef(), useRef(), useRef(), useRef()];

  const sendOTP = () => {
    if (mobile.replace(/\D/g, "").length < 10) { setError("Enter a valid 10-digit mobile number"); return; }
    setSending(true); setError("");
    setTimeout(() => { setSending(false); setStep(2); }, 1200);
  };

  const handleOTPKey = (i, val) => {
    const d = val.replace(/\D/g, "").slice(-1);
    const next = [...otp]; next[i] = d; setOtp(next);
    if (d && i < 5) refs[i + 1].current?.focus();
    if (!d && i > 0) refs[i - 1].current?.focus();
  };

  const handlePaste = (e) => {
    const p = e.clipboardData.getData("text").replace(/\D/g, "").slice(0, 6);
    if (p.length === 6) { setOtp(p.split("")); refs[5].current?.focus(); }
  };

  const verify = () => {
    const code = otp.join("");
    if (code.length < 6) { setError("Enter the 6-digit OTP"); return; }
    setVerifying(true); setError("");
    setTimeout(() => { if (code === "123456") { onLogin(); } else { setVerifying(false); setError("Incorrect OTP. Use 123456 for demo."); } }, 1000);
  };

  return (
    <div style={{ minHeight: "100vh", display: "flex", background: BG }}>
      {/* Left panel */}
      <div style={{ width: "45%", background: `linear-gradient(145deg, ${NAVY} 0%, #1e3a5f 100%)`, display: "flex", flexDirection: "column", padding: "48px 52px", position: "relative", overflow: "hidden" }}>
        <div style={{ position: "absolute", top: -80, right: -80, width: 300, height: 300, background: "rgba(192,57,43,0.15)", borderRadius: "50%" }} />
        <div style={{ position: "absolute", bottom: -100, left: -60, width: 380, height: 380, background: "rgba(255,255,255,0.03)", borderRadius: "50%" }} />
        <div style={{ position: "relative", zIndex: 1 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 60 }}>
            <div style={{ width: 40, height: 40, background: R, borderRadius: 10, display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 900, color: WHITE, fontSize: 15 }}>BRL</div>
            <div>
              <div style={{ color: WHITE, fontWeight: 700, fontSize: 15, letterSpacing: 0.5 }}>Best Roadways</div>
              <div style={{ color: "rgba(255,255,255,0.4)", fontSize: 11, fontFamily: "'DM Mono', monospace" }}>Customer Portal</div>
            </div>
          </div>
          <h1 style={{ color: WHITE, fontSize: 32, fontWeight: 800, lineHeight: 1.25, margin: "0 0 16px" }}>Track. Manage.<br /><span style={{ color: "#f87171" }}>Stay in Control.</span></h1>
          <p style={{ color: "rgba(255,255,255,0.55)", fontSize: 14, lineHeight: 1.7, margin: "0 0 40px" }}>Your complete logistics dashboard — track shipments, download PODs, manage outstanding invoices, and raise queries in one place.</p>
          <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
            {["📦 Real-time shipment tracking", "📄 Instant POD & invoice downloads", "💳 Outstanding & account statement", "🎫 Grievance management with SLA", "📊 MIS reports on demand"].map((f, i) => (
              <div key={i} style={{ display: "flex", alignItems: "center", gap: 10, color: "rgba(255,255,255,0.75)", fontSize: 13 }}>
                <div style={{ width: 6, height: 6, background: R, borderRadius: "50%", flexShrink: 0 }} />
                {f}
              </div>
            ))}
          </div>
        </div>
        <div style={{ position: "relative", zIndex: 1, marginTop: "auto", color: "rgba(255,255,255,0.25)", fontSize: 11 }}>
          © 2026 Best Roadways Limited · 40 Years of Logistics Excellence
        </div>
      </div>

      {/* Right panel */}
      <div style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", padding: 40 }}>
        <div style={{ width: "100%", maxWidth: 400 }}>
          {step === 1 ? (
            <div>
              <h2 style={{ fontSize: 24, fontWeight: 800, color: NAVY, margin: "0 0 6px" }}>Welcome back</h2>
              <p style={{ color: MUTED, fontSize: 14, margin: "0 0 32px" }}>Sign in with your registered mobile number</p>
              <div style={{ marginBottom: 14 }}>
                <label style={{ fontSize: 12, fontWeight: 700, color: NAVY2, display: "block", marginBottom: 6, textTransform: "uppercase", letterSpacing: 0.5 }}>Mobile Number</label>
                <div style={{ display: "flex", border: `1.5px solid ${BORDER}`, borderRadius: 10, overflow: "hidden", background: WHITE }}>
                  <div style={{ padding: "10px 14px", background: "#f8fafc", borderRight: `1px solid ${BORDER}`, fontSize: 13, color: MUTED, fontWeight: 600 }}>+91</div>
                  <input value={mobile} onChange={e => { setMobile(e.target.value); setError(""); }} placeholder="98200 12345" style={{ flex: 1, padding: "10px 14px", border: "none", outline: "none", fontSize: 14, fontFamily: "'DM Mono', monospace", color: NAVY2 }} onKeyDown={e => e.key === "Enter" && sendOTP()} maxLength={10} />
                </div>
              </div>
              {error && <div style={{ color: R, fontSize: 12, marginBottom: 12, fontWeight: 600 }}>⚠ {error}</div>}
              <Btn full variant="primary" onClick={sendOTP} disabled={sending} size="lg">{sending ? "Sending OTP..." : "Send OTP →"}</Btn>
              <p style={{ textAlign: "center", marginTop: 16, fontSize: 12, color: MUTED }}>
                New to the portal? Contact your BRL Key Account Manager
              </p>
            </div>
          ) : (
            <div>
              <button onClick={() => { setStep(1); setOtp(["","","","","",""]); setError(""); }} style={{ background: "none", border: "none", color: MUTED, cursor: "pointer", fontSize: 13, padding: 0, marginBottom: 20, display: "flex", alignItems: "center", gap: 6, fontFamily: "inherit" }}>← Back</button>
              <h2 style={{ fontSize: 24, fontWeight: 800, color: NAVY, margin: "0 0 6px" }}>Enter OTP</h2>
              <p style={{ color: MUTED, fontSize: 13, margin: "0 0 8px" }}>Sent to +91 {mobile}</p>
              <div style={{ background: "#fef3c7", borderRadius: 8, padding: "8px 14px", marginBottom: 24, fontSize: 12, color: "#92400e", fontWeight: 600 }}>
                Demo OTP: 1 2 3 4 5 6
              </div>
              <div style={{ display: "flex", gap: 10, marginBottom: 20, justifyContent: "center" }}>
                {otp.map((d, i) => (
                  <input key={i} ref={refs[i]} value={d} onChange={e => handleOTPKey(i, e.target.value)} onPaste={handlePaste} maxLength={1} style={{ width: 48, height: 54, textAlign: "center", fontSize: 22, fontWeight: 700, fontFamily: "'DM Mono', monospace", border: `2px solid ${d ? R : BORDER}`, borderRadius: 10, outline: "none", color: NAVY, background: d ? "#fff5f5" : WHITE, transition: "all 0.15s" }} />
                ))}
              </div>
              {error && <div style={{ color: R, fontSize: 12, marginBottom: 12, textAlign: "center", fontWeight: 600 }}>⚠ {error}</div>}
              <Btn full variant="primary" onClick={verify} disabled={verifying} size="lg">{verifying ? "Verifying..." : "Sign In →"}</Btn>
              <p style={{ textAlign: "center", marginTop: 14, fontSize: 12, color: MUTED }}>Didn't receive? <span style={{ color: R, cursor: "pointer", fontWeight: 600 }}>Resend in 30s</span></p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

// ── DASHBOARD ──────────────────────────────────────────────────────────────
function Dashboard({ setPage }) {
  const totalOutstanding = INVOICES.reduce((a, i) => a + i.amount, 0);
  const creditPct = Math.round((USER.credit_used / USER.credit_limit) * 100);
  return (
    <div>
      <div style={{ background: `linear-gradient(135deg, ${NAVY} 0%, #1e3a5f 100%)`, borderRadius: 16, padding: "28px 32px", marginBottom: 24, color: WHITE, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <div>
          <div style={{ fontSize: 12, opacity: 0.5, fontWeight: 600, textTransform: "uppercase", letterSpacing: 1, marginBottom: 6 }}>Welcome back</div>
          <h1 style={{ margin: 0, fontSize: 24, fontWeight: 800 }}>Hi, {USER.name} 👋</h1>
          <div style={{ opacity: 0.6, fontSize: 13, marginTop: 4 }}>{USER.company} · KAM: {USER.kam} ({USER.kam_phone})</div>
        </div>
        <div style={{ textAlign: "right" }}>
          <div style={{ fontSize: 11, opacity: 0.4, marginBottom: 4 }}>Credit Utilisation</div>
          <div style={{ fontSize: 22, fontWeight: 800, fontFamily: "'DM Mono', monospace" }}>{creditPct}%</div>
          <div style={{ width: 160, marginTop: 6 }}><ProgressBar pct={creditPct} color={creditPct > 80 ? "#f87171" : "#86efac"} height={5} /></div>
          <div style={{ fontSize: 11, opacity: 0.4, marginTop: 4 }}>₹{(USER.credit_used / 100000).toFixed(1)}L used of ₹{USER.credit_limit / 100000}L</div>
        </div>
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 14, marginBottom: 24 }}>
        <KpiCard label="Active Shipments" value={SHIPMENTS.filter(s => s.status !== "Delivered").length} sub="1 out for delivery" icon="🚛" accent={BLUE} />
        <KpiCard label="Outstanding" value={`₹${(totalOutstanding / 100000).toFixed(1)}L`} sub="2 invoices overdue" icon="💳" accent={R} />
        <KpiCard label="Unbilled CNs" value={UNBILLED.length} sub="Pending invoicing" icon="📄" accent={AMBER} />
        <KpiCard label="Open Grievances" value={GRIEVANCES.filter(g => g.status !== "Resolved").length} sub="1 high priority" icon="🎫" accent="#7c3aed" />
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "1.6fr 1fr", gap: 18, marginBottom: 18 }}>
        <Card>
          <SectionTitle title="Active Shipments" action={<Btn size="sm" variant="ghost" onClick={() => setPage("track")}>View All</Btn>} />
          {SHIPMENTS.filter(s => s.status !== "Delivered").map(s => (
            <div key={s.cn} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "12px 0", borderBottom: `1px solid ${BORDER}` }}>
              <div style={{ flex: 1 }}>
                <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 4 }}>
                  <span style={{ fontFamily: "'DM Mono', monospace", fontSize: 12, fontWeight: 700, color: NAVY }}>{s.cn}</span>
                  <Badge label={s.status} status={s.status} />
                </div>
                <div style={{ fontSize: 12, color: MUTED }}>{s.from} → {s.to} · {s.pkgs} pkgs · ETA {s.eta}</div>
                {s.status !== "Booked" && <div style={{ marginTop: 6 }}><ProgressBar pct={s.route_pct} color={s.status === "Out for Delivery" ? AMBER : BLUE} /></div>}
              </div>
            </div>
          ))}
        </Card>

        <Card>
          <SectionTitle title="Quick Actions" />
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
            {[
              { icon: "🔍", label: "Track Shipment", page: "track" },
              { icon: "📄", label: "Download POD", page: "documents" },
              { icon: "💳", label: "View Outstanding", page: "outstanding" },
              { icon: "🎫", label: "Raise Grievance", page: "grievances" },
              { icon: "📅", label: "Schedule Pickup", page: "pickup" },
              { icon: "📊", label: "MIS Reports", page: "reports" },
            ].map(q => (
              <button key={q.page} onClick={() => setPage(q.page)} style={{ background: BG, border: `1px solid ${BORDER}`, borderRadius: 10, padding: "12px 10px", cursor: "pointer", textAlign: "center", transition: "all 0.15s", fontFamily: "inherit" }}
                onMouseEnter={e => { e.currentTarget.style.background = "#fff5f5"; e.currentTarget.style.borderColor = R; }}
                onMouseLeave={e => { e.currentTarget.style.background = BG; e.currentTarget.style.borderColor = BORDER; }}>
                <div style={{ fontSize: 20, marginBottom: 4 }}>{q.icon}</div>
                <div style={{ fontSize: 11, fontWeight: 700, color: NAVY2 }}>{q.label}</div>
              </button>
            ))}
          </div>
        </Card>
      </div>

      <Card>
        <SectionTitle title="Recent Invoices" action={<Btn size="sm" variant="ghost" onClick={() => setPage("outstanding")}>View All</Btn>} />
        <div style={{ overflowX: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
            <thead><tr style={{ background: "#f8fafc" }}>
              {["Invoice No", "CN", "Date", "Due Date", "Amount (₹)", "Aging", "Status"].map(h => (
                <th key={h} style={{ padding: "9px 14px", textAlign: "left", fontSize: 11, fontWeight: 700, color: MUTED, textTransform: "uppercase", letterSpacing: 0.5, borderBottom: `1px solid ${BORDER}` }}>{h}</th>
              ))}
            </tr></thead>
            <tbody>{INVOICES.slice(0, 4).map(inv => (
              <tr key={inv.inv} style={{ borderBottom: `1px solid #f8fafc` }}
                onMouseEnter={e => e.currentTarget.style.background = "#fafafa"}
                onMouseLeave={e => e.currentTarget.style.background = ""}>
                <td style={{ padding: "10px 14px", fontFamily: "'DM Mono', monospace", fontSize: 12, fontWeight: 700, color: NAVY }}>{inv.inv}</td>
                <td style={{ padding: "10px 14px", fontFamily: "'DM Mono', monospace", fontSize: 12, color: MUTED }}>{inv.cn}</td>
                <td style={{ padding: "10px 14px", fontSize: 12 }}>{inv.date}</td>
                <td style={{ padding: "10px 14px", fontSize: 12 }}>{inv.due}</td>
                <td style={{ padding: "10px 14px", fontFamily: "'DM Mono', monospace", fontSize: 13, fontWeight: 700, color: NAVY }}>₹{inv.amount.toLocaleString("en-IN")}</td>
                <td style={{ padding: "10px 14px", fontSize: 12, color: inv.aging > 30 ? R : inv.aging > 7 ? AMBER : GREEN, fontWeight: 700 }}>{inv.aging}d</td>
                <td style={{ padding: "10px 14px" }}><Badge label={inv.status} status={inv.status} /></td>
              </tr>
            ))}</tbody>
          </table>
        </div>
      </Card>
    </div>
  );
}

// ── TRACK SHIPMENT ─────────────────────────────────────────────────────────
function TrackShipment() {
  const [query, setQuery] = useState("");
  const [selected, setSelected] = useState(null);
  const filtered = query.length > 2 ? SHIPMENTS.filter(s => s.cn.includes(query.toUpperCase()) || s.lr.includes(query.toUpperCase())) : SHIPMENTS;

  const TIMELINE = {
    "Booked": ["Booked"],
    "In Transit": ["Booked", "Picked Up", "In Transit"],
    "Out for Delivery": ["Booked", "Picked Up", "In Transit", "Out for Delivery"],
    "Delivered": ["Booked", "Picked Up", "In Transit", "Out for Delivery", "Delivered"],
  };
  const ALL_STEPS = ["Booked", "Picked Up", "In Transit", "Out for Delivery", "Delivered"];

  return (
    <div>
      <SectionTitle title="Track Shipment" sub="Real-time status across all your consignments" />
      <Card style={{ marginBottom: 18 }}>
        <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
          <div style={{ flex: 1, position: "relative" }}>
            <span style={{ position: "absolute", left: 12, top: "50%", transform: "translateY(-50%)", fontSize: 16 }}>🔍</span>
            <input value={query} onChange={e => setQuery(e.target.value)} placeholder="Search by CN or LR number…" style={{ width: "100%", padding: "10px 14px 10px 38px", border: `1.5px solid ${BORDER}`, borderRadius: 10, fontSize: 14, fontFamily: "inherit", outline: "none", boxSizing: "border-box" }} />
          </div>
          <Btn variant="primary" onClick={() => {}}>Search</Btn>
        </div>
      </Card>

      <div style={{ display: "grid", gridTemplateColumns: selected ? "1fr 1.2fr" : "1fr", gap: 16 }}>
        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
          {filtered.map(s => (
            <Card key={s.cn} style={{ cursor: "pointer", border: selected?.cn === s.cn ? `2px solid ${R}` : `1px solid ${BORDER}`, transition: "all 0.15s" }} >
              <div onClick={() => setSelected(selected?.cn === s.cn ? null : s)} style={{}}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 10 }}>
                  <div>
                    <div style={{ fontFamily: "'DM Mono', monospace", fontWeight: 700, fontSize: 14, color: NAVY }}>{s.cn}</div>
                    <div style={{ fontSize: 12, color: MUTED, marginTop: 2 }}>{s.lr} · {s.material}</div>
                  </div>
                  <Badge label={s.status} status={s.status} />
                </div>
                <div style={{ display: "flex", gap: 16, fontSize: 12, color: MUTED, marginBottom: 12 }}>
                  <span>📍 {s.from} → {s.to}</span>
                  <span>📦 {s.pkgs} pkgs · {s.weight}</span>
                  <span>📅 ETA: {s.eta}</span>
                </div>
                {s.status !== "Booked" && <ProgressBar pct={s.route_pct} color={s.status === "Delivered" ? GREEN : s.status === "Out for Delivery" ? AMBER : BLUE} />}
              </div>
            </Card>
          ))}
        </div>

        {selected && (
          <Card>
            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 16 }}>
              <div>
                <div style={{ fontFamily: "'DM Mono', monospace", fontWeight: 800, fontSize: 16, color: NAVY }}>{selected.cn}</div>
                <div style={{ fontSize: 12, color: MUTED }}>{selected.consignee}</div>
              </div>
              <button onClick={() => setSelected(null)} style={{ background: "none", border: "none", fontSize: 18, cursor: "pointer", color: MUTED }}>✕</button>
            </div>

            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, marginBottom: 18 }}>
              {[["Origin", selected.from], ["Destination", selected.to], ["Packages", selected.pkgs], ["Weight", selected.weight], ["Vehicle", selected.vehicle || "—"], ["Driver", selected.driver || "—"]].map(([k, v]) => (
                <div key={k} style={{ background: BG, borderRadius: 8, padding: "8px 12px" }}>
                  <div style={{ fontSize: 10, color: MUTED, fontWeight: 700, textTransform: "uppercase", marginBottom: 2 }}>{k}</div>
                  <div style={{ fontSize: 13, fontWeight: 600, color: NAVY2, fontFamily: k === "Vehicle" || k === "Weight" ? "'DM Mono', monospace" : "inherit" }}>{v}</div>
                </div>
              ))}
            </div>

            <div style={{ marginBottom: 16 }}>
              <div style={{ fontSize: 12, fontWeight: 700, color: MUTED, textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 14 }}>Shipment Timeline</div>
              {ALL_STEPS.map((step, i) => {
                const done = (TIMELINE[selected.status] || []).includes(step);
                const current = TIMELINE[selected.status]?.[TIMELINE[selected.status].length - 1] === step;
                return (
                  <div key={step} style={{ display: "flex", gap: 14, marginBottom: i < ALL_STEPS.length - 1 ? 0 : 0 }}>
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                      <div style={{ width: 14, height: 14, borderRadius: "50%", background: done ? (current ? R : GREEN) : BORDER, border: `2px solid ${done ? (current ? R : GREEN) : BORDER}`, flexShrink: 0, marginTop: 3 }} />
                      {i < ALL_STEPS.length - 1 && <div style={{ width: 2, height: 28, background: done && !current ? GREEN : BORDER, margin: "2px 0" }} />}
                    </div>
                    <div style={{ paddingBottom: i < ALL_STEPS.length - 1 ? 12 : 0 }}>
                      <div style={{ fontSize: 13, fontWeight: current ? 700 : 500, color: done ? NAVY : MUTED }}>{step}</div>
                      {current && <div style={{ fontSize: 11, color: R, fontWeight: 600 }}>Current Status</div>}
                    </div>
                  </div>
                );
              })}
            </div>

            {selected.pod && (
              <Btn full variant="success">📄 Download POD</Btn>
            )}
          </Card>
        )}
      </div>
    </div>
  );
}

// ── OUTSTANDING ────────────────────────────────────────────────────────────
function Outstanding() {
  const total = INVOICES.reduce((a, i) => a + i.amount, 0);
  const overdue = INVOICES.filter(i => i.status === "Overdue").reduce((a, i) => a + i.amount, 0);
  return (
    <div>
      <SectionTitle title="Outstanding & Account Statement" />
      <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 14, marginBottom: 20 }}>
        <KpiCard label="Total Outstanding" value={`₹${(total / 100000).toFixed(2)}L`} sub="Across all invoices" icon="💳" accent={R} />
        <KpiCard label="Overdue Amount" value={`₹${(overdue / 100000).toFixed(2)}L`} sub="2 invoices past due" icon="⚠️" accent={R} />
        <KpiCard label="Credit Available" value={`₹${((USER.credit_limit - USER.credit_used) / 100000).toFixed(2)}L`} sub={`of ₹${USER.credit_limit / 100000}L limit`} icon="✅" accent={GREEN} />
      </div>

      <Card style={{ marginBottom: 18 }}>
        <SectionTitle title="Invoice Ledger" action={
          <div style={{ display: "flex", gap: 8 }}>
            <input type="date" defaultValue="2026-01-01" style={{ padding: "6px 10px", border: `1px solid ${BORDER}`, borderRadius: 8, fontSize: 12, fontFamily: "inherit" }} />
            <input type="date" defaultValue="2026-04-06" style={{ padding: "6px 10px", border: `1px solid ${BORDER}`, borderRadius: 8, fontSize: 12, fontFamily: "inherit" }} />
            <Btn size="sm" variant="secondary">📊 Export</Btn>
          </div>
        } />
        <div style={{ overflowX: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
            <thead><tr style={{ background: "#f8fafc" }}>
              {["Invoice No", "CN", "Invoice Date", "Due Date", "Amount (₹)", "Aging (Days)", "Status", "Action"].map(h => (
                <th key={h} style={{ padding: "9px 14px", textAlign: "left", fontSize: 11, fontWeight: 700, color: MUTED, textTransform: "uppercase", letterSpacing: 0.5, borderBottom: `1px solid ${BORDER}`, whiteSpace: "nowrap" }}>{h}</th>
              ))}
            </tr></thead>
            <tbody>{INVOICES.map(inv => (
              <tr key={inv.inv} onMouseEnter={e => e.currentTarget.style.background = "#fafafa"} onMouseLeave={e => e.currentTarget.style.background = ""}>
                <td style={{ padding: "11px 14px", fontFamily: "'DM Mono', monospace", fontSize: 12, fontWeight: 700, color: NAVY, borderBottom: `1px solid #f8fafc` }}>{inv.inv}</td>
                <td style={{ padding: "11px 14px", fontFamily: "'DM Mono', monospace", fontSize: 12, color: MUTED, borderBottom: `1px solid #f8fafc` }}>{inv.cn}</td>
                <td style={{ padding: "11px 14px", fontSize: 12, borderBottom: `1px solid #f8fafc` }}>{inv.date}</td>
                <td style={{ padding: "11px 14px", fontSize: 12, borderBottom: `1px solid #f8fafc` }}>{inv.due}</td>
                <td style={{ padding: "11px 14px", fontFamily: "'DM Mono', monospace", fontSize: 13, fontWeight: 700, color: NAVY, borderBottom: `1px solid #f8fafc` }}>₹{inv.amount.toLocaleString("en-IN")}</td>
                <td style={{ padding: "11px 14px", borderBottom: `1px solid #f8fafc` }}>
                  <span style={{ fontWeight: 700, color: inv.aging > 30 ? R : inv.aging > 7 ? AMBER : GREEN, fontFamily: "'DM Mono', monospace" }}>{inv.aging}d</span>
                </td>
                <td style={{ padding: "11px 14px", borderBottom: `1px solid #f8fafc` }}><Badge label={inv.status} status={inv.status} /></td>
                <td style={{ padding: "11px 14px", borderBottom: `1px solid #f8fafc` }}>
                  <div style={{ display: "flex", gap: 6 }}>
                    <Btn size="sm" variant="secondary">Download</Btn>
                    {inv.status === "Overdue" && <Btn size="sm" variant="danger">Dispute</Btn>}
                  </div>
                </td>
              </tr>
            ))}</tbody>
            <tfoot>
              <tr style={{ background: "#f8fafc", borderTop: `2px solid ${BORDER}` }}>
                <td colSpan={4} style={{ padding: "10px 14px", fontWeight: 700, fontSize: 13, color: NAVY }}>Total Outstanding</td>
                <td style={{ padding: "10px 14px", fontFamily: "'DM Mono', monospace", fontSize: 14, fontWeight: 800, color: R }}>₹{total.toLocaleString("en-IN")}</td>
                <td colSpan={3} />
              </tr>
            </tfoot>
          </table>
        </div>
      </Card>

      <Card>
        <SectionTitle title="Account Ledger" sub="Complete debit/credit history" action={<Btn size="sm" variant="secondary">📥 Download PDF</Btn>} />
        <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
          <thead><tr style={{ background: "#f8fafc" }}>
            {["Date", "Reference", "Type", "Debit (₹)", "Credit (₹)", "Balance (₹)"].map(h => (
              <th key={h} style={{ padding: "9px 14px", textAlign: "left", fontSize: 11, fontWeight: 700, color: MUTED, textTransform: "uppercase", letterSpacing: 0.5, borderBottom: `1px solid ${BORDER}` }}>{h}</th>
            ))}
          </tr></thead>
          <tbody>{LEDGER.map((l, i) => (
            <tr key={i} onMouseEnter={e => e.currentTarget.style.background = "#fafafa"} onMouseLeave={e => e.currentTarget.style.background = ""} style={{ borderBottom: `1px solid #f8fafc` }}>
              <td style={{ padding: "10px 14px", fontSize: 12, fontFamily: "'DM Mono', monospace" }}>{l.date}</td>
              <td style={{ padding: "10px 14px", fontSize: 12, fontFamily: "'DM Mono', monospace", fontWeight: 600, color: NAVY }}>{l.ref}</td>
              <td style={{ padding: "10px 14px" }}>
                <span style={{ background: l.type === "Payment" ? "#dcfce7" : l.type === "Credit Note" ? "#dbeafe" : "#f1f5f9", color: l.type === "Payment" ? GREEN : l.type === "Credit Note" ? BLUE : MUTED, padding: "2px 8px", borderRadius: 4, fontSize: 11, fontWeight: 700 }}>{l.type}</span>
              </td>
              <td style={{ padding: "10px 14px", fontFamily: "'DM Mono', monospace", fontSize: 12, color: l.debit ? R : MUTED }}>{l.debit ? `₹${l.debit.toLocaleString("en-IN")}` : "—"}</td>
              <td style={{ padding: "10px 14px", fontFamily: "'DM Mono', monospace", fontSize: 12, color: l.credit ? GREEN : MUTED }}>{l.credit ? `₹${l.credit.toLocaleString("en-IN")}` : "—"}</td>
              <td style={{ padding: "10px 14px", fontFamily: "'DM Mono', monospace", fontSize: 13, fontWeight: 700, color: NAVY }}>₹{l.balance.toLocaleString("en-IN")}</td>
            </tr>
          ))}</tbody>
        </table>
      </Card>
    </div>
  );
}

// ── DOCUMENTS ──────────────────────────────────────────────────────────────
function Documents() {
  return (
    <div>
      <SectionTitle title="Documents" sub="Download POD, LR copies, invoices and e-way bills" />
      {SHIPMENTS.map(s => (
        <Card key={s.cn} style={{ marginBottom: 14 }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 14 }}>
            <div>
              <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                <span style={{ fontFamily: "'DM Mono', monospace", fontWeight: 700, fontSize: 14, color: NAVY }}>{s.cn}</span>
                <Badge label={s.status} status={s.status} />
              </div>
              <div style={{ fontSize: 12, color: MUTED, marginTop: 3 }}>{s.from} → {s.to} · {s.material} · {s.booked}</div>
            </div>
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 10 }}>
            {[
              { label: "LR Copy", icon: "📋", available: true, type: "lr" },
              { label: "E-Way Bill", icon: "📄", available: s.status !== "Booked", type: "ewb" },
              { label: "Invoice", icon: "🧾", available: true, type: "inv" },
              { label: "POD", icon: "📷", available: s.pod, type: "pod" },
            ].map(doc => (
              <div key={doc.type} style={{ background: doc.available ? BG : "#f8fafc", border: `1px solid ${doc.available ? BORDER : "#f1f5f9"}`, borderRadius: 10, padding: "12px 14px", display: "flex", flexDirection: "column", gap: 6, opacity: doc.available ? 1 : 0.4 }}>
                <div style={{ fontSize: 22 }}>{doc.icon}</div>
                <div style={{ fontSize: 12, fontWeight: 700, color: NAVY }}>{doc.label}</div>
                <div style={{ fontSize: 11, color: MUTED }}>{doc.available ? "Available" : "Not yet"}</div>
                <Btn size="sm" variant={doc.available ? "primary" : "secondary"} disabled={!doc.available} onClick={() => alert(`Downloading ${doc.label} for ${s.cn}...`)}>Download</Btn>
              </div>
            ))}
          </div>
        </Card>
      ))}
    </div>
  );
}

// ── GRIEVANCES ─────────────────────────────────────────────────────────────
function Grievances() {
  const [showForm, setShowForm] = useState(false);
  const [expanded, setExpanded] = useState(null);
  const [type, setType] = useState("");
  const [cn, setCn] = useState("");
  const [subject, setSubject] = useState("");
  const [desc, setDesc] = useState("");

  return (
    <div>
      <SectionTitle title="Grievance Management" sub="Raise and track complaints with SLA-bound resolution" action={<Btn variant="primary" onClick={() => setShowForm(true)}>+ Raise New Grievance</Btn>} />

      {showForm && (
        <Card style={{ marginBottom: 18, border: `2px solid ${R}` }}>
          <SectionTitle title="New Grievance" action={<button onClick={() => setShowForm(false)} style={{ background: "none", border: "none", fontSize: 18, cursor: "pointer", color: MUTED }}>✕</button>} />
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14 }}>
            <Sel label="Type of Grievance" required>
              <option>Select type...</option>
              <option>Damage / Shortage</option>
              <option>Transit Delay</option>
              <option>Invoice Dispute</option>
              <option>POD Not Received</option>
              <option>Service Quality</option>
              <option>Other</option>
            </Sel>
            <Sel label="Related Consignment" required>
              <option>Select CN...</option>
              {SHIPMENTS.map(s => <option key={s.cn}>{s.cn} — {s.from} to {s.to}</option>)}
            </Sel>
          </div>
          <Input label="Subject" placeholder="Brief description of the issue" required />
          <div style={{ marginBottom: 14 }}>
            <label style={{ fontSize: 12, fontWeight: 700, color: NAVY2, display: "block", marginBottom: 5, textTransform: "uppercase", letterSpacing: 0.5 }}>Detailed Description <span style={{ color: R }}>*</span></label>
            <textarea placeholder="Describe the issue in detail — include quantities, values, and any reference numbers..." rows={4} style={{ width: "100%", padding: "9px 12px", border: `1.5px solid ${BORDER}`, borderRadius: 8, fontSize: 13, fontFamily: "inherit", resize: "vertical", boxSizing: "border-box" }} />
          </div>
          <div style={{ marginBottom: 18 }}>
            <label style={{ fontSize: 12, fontWeight: 700, color: NAVY2, display: "block", marginBottom: 5, textTransform: "uppercase", letterSpacing: 0.5 }}>Attachments (Optional)</label>
            <div style={{ border: `2px dashed ${BORDER}`, borderRadius: 10, padding: "20px", textAlign: "center", color: MUTED, fontSize: 13, cursor: "pointer" }}>📎 Click to attach photos, documents or invoices</div>
          </div>
          <div style={{ display: "flex", gap: 10 }}>
            <Btn variant="secondary" onClick={() => setShowForm(false)}>Cancel</Btn>
            <Btn variant="primary" onClick={() => { alert("GRV-2026-0046 raised successfully. SLA: 48 hours. Assigned to: Kapil Agarwal"); setShowForm(false); }}>Submit Grievance</Btn>
          </div>
        </Card>
      )}

      <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
        {GRIEVANCES.map(g => (
          <Card key={g.id} style={{ border: g.status === "In Progress" ? `1.5px solid ${AMBER}` : `1px solid ${BORDER}` }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 12, cursor: "pointer" }} onClick={() => setExpanded(expanded === g.id ? null : g.id)}>
              <div style={{ flex: 1 }}>
                <div style={{ display: "flex", gap: 8, alignItems: "center", marginBottom: 4 }}>
                  <span style={{ fontFamily: "'DM Mono', monospace", fontWeight: 700, fontSize: 13, color: NAVY }}>{g.id}</span>
                  <Badge label={g.status} status={g.status} />
                  <Badge label={g.priority} status={g.priority} />
                </div>
                <div style={{ fontSize: 13, fontWeight: 600, color: NAVY2, marginBottom: 3 }}>{g.subject}</div>
                <div style={{ fontSize: 12, color: MUTED }}>{g.type} · {g.cn} · Raised {g.raised} · Assigned to {g.assigned}</div>
              </div>
              <span style={{ color: MUTED, fontSize: 14, marginLeft: 12 }}>{expanded === g.id ? "▲" : "▼"}</span>
            </div>

            {g.status !== "Resolved" && (
              <div style={{ marginBottom: expanded === g.id ? 16 : 0 }}>
                <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 5 }}>
                  <span style={{ fontSize: 11, color: MUTED, fontWeight: 600 }}>SLA Progress ({g.elapsed_hours}h / {g.sla_hours}h)</span>
                  <span style={{ fontSize: 11, fontWeight: 700, color: g.elapsed_hours / g.sla_hours > 0.8 ? R : AMBER }}>{Math.round((g.elapsed_hours / g.sla_hours) * 100)}%</span>
                </div>
                <ProgressBar pct={Math.round((g.elapsed_hours / g.sla_hours) * 100)} color={g.elapsed_hours / g.sla_hours > 0.8 ? R : AMBER} height={7} />
              </div>
            )}

            {expanded === g.id && (
              <div style={{ marginTop: 16, borderTop: `1px solid ${BORDER}`, paddingTop: 16 }}>
                <div style={{ fontSize: 12, fontWeight: 700, color: MUTED, textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 12 }}>Activity Log</div>
                {g.updates.map((u, i) => (
                  <div key={i} style={{ display: "flex", gap: 12, marginBottom: 10 }}>
                    <div style={{ width: 8, height: 8, borderRadius: "50%", background: i === g.updates.length - 1 ? R : "#cbd5e1", marginTop: 5, flexShrink: 0 }} />
                    <div>
                      <div style={{ fontSize: 12, color: MUTED, fontFamily: "'DM Mono', monospace" }}>{u.time}</div>
                      <div style={{ fontSize: 13, color: NAVY2 }}>{u.msg}</div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </Card>
        ))}
      </div>
    </div>
  );
}

// ── SCHEDULE PICKUP ────────────────────────────────────────────────────────
function SchedulePickup() {
  const [submitted, setSubmitted] = useState(false);
  if (submitted) return (
    <div style={{ textAlign: "center", padding: 60 }}>
      <div style={{ fontSize: 56, marginBottom: 16 }}>✅</div>
      <h2 style={{ color: NAVY, margin: "0 0 8px" }}>Pickup Scheduled!</h2>
      <p style={{ color: MUTED, fontSize: 14 }}>Booking Ref: <strong style={{ fontFamily: "'DM Mono', monospace" }}>PKP-2026-{Math.floor(Math.random() * 9000 + 1000)}</strong></p>
      <p style={{ color: MUTED, fontSize: 13 }}>Our team will confirm within 30 minutes. You'll receive a WhatsApp notification.</p>
      <Btn variant="primary" onClick={() => setSubmitted(false)}>Schedule Another</Btn>
    </div>
  );
  return (
    <div>
      <SectionTitle title="Schedule Pickup" sub="Book a new freight pickup request" />
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 20 }}>
        <div>
          <Card style={{ marginBottom: 16 }}>
            <div style={{ fontWeight: 700, fontSize: 14, color: NAVY, marginBottom: 14 }}>Pickup Details</div>
            <Input label="Pickup Address" placeholder="Enter full pickup address" required />
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
              <Input label="City" placeholder="Pickup city" required />
              <Input label="Pincode" placeholder="6-digit pincode" required />
            </div>
            <Input label="Preferred Pickup Date" type="date" required />
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
              <Input label="Preferred Time (From)" type="time" />
              <Input label="Preferred Time (To)" type="time" />
            </div>
            <Input label="Contact Person at Pickup" placeholder="Name and mobile" required />
          </Card>
        </div>
        <div>
          <Card style={{ marginBottom: 16 }}>
            <div style={{ fontWeight: 700, fontSize: 14, color: NAVY, marginBottom: 14 }}>Delivery Details</div>
            <Input label="Delivery Address" placeholder="Enter full delivery address" required />
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
              <Input label="City" placeholder="Delivery city" required />
              <Input label="Pincode" placeholder="6-digit pincode" required />
            </div>
            <Sel label="Delivery Type" required>
              <option>Door Delivery</option>
              <option>Godown Delivery</option>
              <option>CFS Delivery</option>
              <option>To-Pay</option>
            </Sel>
          </Card>
          <Card>
            <div style={{ fontWeight: 700, fontSize: 14, color: NAVY, marginBottom: 14 }}>Cargo Details</div>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
              <Input label="Material Type" placeholder="e.g. Agrochemicals" required />
              <Input label="HSN Code" placeholder="e.g. 3808" />
              <Input label="No. of Packages" type="number" placeholder="0" required />
              <Input label="Total Weight (kg)" type="number" placeholder="0" required />
            </div>
            <Input label="Invoice Value (₹)" type="number" placeholder="For e-way bill purposes" />
            <div style={{ marginBottom: 14 }}>
              <label style={{ fontSize: 12, fontWeight: 700, color: NAVY2, display: "block", marginBottom: 5, textTransform: "uppercase", letterSpacing: 0.5 }}>Special Instructions</label>
              <textarea placeholder="Fragile, temperature-sensitive, etc." rows={2} style={{ width: "100%", padding: "9px 12px", border: `1.5px solid ${BORDER}`, borderRadius: 8, fontSize: 13, fontFamily: "inherit", resize: "none", boxSizing: "border-box" }} />
            </div>
            <Btn full variant="primary" onClick={() => setSubmitted(true)} size="lg">Confirm Pickup Request →</Btn>
          </Card>
        </div>
      </div>
    </div>
  );
}

// ── RATE ENQUIRY ───────────────────────────────────────────────────────────
function RateEnquiry() {
  const [submitted, setSubmitted] = useState(false);
  return (
    <div>
      <SectionTitle title="Rate Enquiry / Spot RFQ" sub="Get a freight rate quote within 30 minutes" />
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 20 }}>
        <Card>
          <div style={{ fontWeight: 700, fontSize: 14, color: NAVY, marginBottom: 14 }}>Enquiry Details</div>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
            <Input label="Origin City" placeholder="e.g. Mumbai" required />
            <Input label="Destination City" placeholder="e.g. Delhi" required />
            <Input label="Weight (kg)" type="number" placeholder="0" required />
            <Input label="Packages" type="number" placeholder="0" required />
          </div>
          <Sel label="Material Type" required>
            <option>Agrochemicals</option>
            <option>Pharmaceuticals</option>
            <option>FMCG</option>
            <option>Machinery</option>
            <option>Chemicals</option>
            <option>Other</option>
          </Sel>
          <Sel label="Service Type">
            <option>FTL (Full Truck Load)</option>
            <option>Part Load</option>
            <option>Express FTL</option>
          </Sel>
          <Input label="Required by Date" type="date" />
          <div style={{ marginBottom: 14 }}>
            <label style={{ fontSize: 12, fontWeight: 700, color: NAVY2, display: "block", marginBottom: 5, textTransform: "uppercase", letterSpacing: 0.5 }}>Additional Notes</label>
            <textarea rows={2} placeholder="Special vehicle requirement, loading hours, etc." style={{ width: "100%", padding: "9px 12px", border: `1.5px solid ${BORDER}`, borderRadius: 8, fontSize: 13, fontFamily: "inherit", resize: "none", boxSizing: "border-box" }} />
          </div>
          <Btn full variant="primary" onClick={() => setSubmitted(true)} size="lg">Submit Rate Enquiry →</Btn>
        </Card>
        <div>
          {submitted ? (
            <Card style={{ textAlign: "center", padding: 32 }}>
              <div style={{ fontSize: 40, marginBottom: 12 }}>⏱</div>
              <div style={{ fontWeight: 700, fontSize: 16, color: NAVY, marginBottom: 8 }}>Enquiry Submitted!</div>
              <div style={{ fontSize: 13, color: MUTED, marginBottom: 16 }}>Ref: <strong style={{ fontFamily: "'DM Mono', monospace" }}>RFQ-2026-0198</strong></div>
              <div style={{ background: "#fef3c7", borderRadius: 10, padding: 14, fontSize: 13, color: "#92400e", marginBottom: 16 }}>
                Our SPOT team (Kalpana Karan) will respond within <strong>30 minutes</strong> on WhatsApp and email.
              </div>
              <div style={{ fontSize: 12, color: MUTED }}>BRL SPOT RFQ Response Guarantee: 30 minutes during business hours</div>
            </Card>
          ) : (
            <Card style={{ background: `linear-gradient(135deg, ${NAVY} 0%, #1e3a5f 100%)`, color: WHITE }}>
              <div style={{ fontSize: 11, opacity: 0.5, fontWeight: 700, textTransform: "uppercase", letterSpacing: 1, marginBottom: 16 }}>Our Rate Promise</div>
              {[["⚡ 30-Min Response", "SPOT RFQ guaranteed reply within 30 minutes during business hours"],
                ["🔒 Locked Rates", "Quoted rates locked for 24 hours from confirmation"],
                ["🚛 Direct Fleet", "800+ owned vehicles. No broker markups."],
                ["📍 65+ Branches", "Pan-India network for door-to-door coverage"]].map(([h, d]) => (
                <div key={h} style={{ marginBottom: 16 }}>
                  <div style={{ fontWeight: 700, fontSize: 13, marginBottom: 3 }}>{h}</div>
                  <div style={{ fontSize: 12, opacity: 0.6 }}>{d}</div>
                </div>
              ))}
            </Card>
          )}
        </div>
      </div>
    </div>
  );
}

// ── MIS REPORTS ────────────────────────────────────────────────────────────
function MISReports() {
  const reports = [
    { name: "Monthly OTIF Report", desc: "On-time in-full delivery performance", icon: "📈", last: "Apr 2026" },
    { name: "Transit Time Analysis", desc: "Route-wise average transit times vs SLA", icon: "⏱", last: "Apr 2026" },
    { name: "Shipment Summary", desc: "All consignments — date range, route, status", icon: "📦", last: "Apr 2026" },
    { name: "Damage & Shortage Report", desc: "Claims raised, resolved, compensation issued", icon: "⚠️", last: "Q1 2026" },
    { name: "Invoice & Payment Summary", desc: "Invoice raised vs paid, aging analysis", icon: "💳", last: "Apr 2026" },
    { name: "Branch-wise MIS", desc: "Performance breakdown by origin/destination branch", icon: "🗺", last: "Mar 2026" },
  ];
  return (
    <div>
      <SectionTitle title="MIS Reports" sub="Download performance reports on demand — no more waiting for KAM emails" />
      <Card style={{ marginBottom: 20 }}>
        <div style={{ display: "flex", gap: 10, alignItems: "flex-end" }}>
          <div style={{ flex: 1 }}><Input label="Date From" type="date" /></div>
          <div style={{ flex: 1 }}><Input label="Date To" type="date" /></div>
          <div style={{ flex: 1 }}><Sel label="Format"><option>Excel (.xlsx)</option><option>PDF</option><option>CSV</option></Sel></div>
          <div style={{ marginBottom: 14 }}><Btn variant="primary">Apply Filter</Btn></div>
        </div>
      </Card>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 14 }}>
        {reports.map(r => (
          <Card key={r.name} style={{ cursor: "pointer", transition: "all 0.15s" }}
            onMouseEnter={e => { e.currentTarget.style.borderColor = R; e.currentTarget.style.boxShadow = `0 4px 20px rgba(192,57,43,0.1)`; }}
            onMouseLeave={e => { e.currentTarget.style.borderColor = BORDER; e.currentTarget.style.boxShadow = "none"; }}>
            <div style={{ fontSize: 32, marginBottom: 10 }}>{r.icon}</div>
            <div style={{ fontWeight: 700, fontSize: 14, color: NAVY, marginBottom: 4 }}>{r.name}</div>
            <div style={{ fontSize: 12, color: MUTED, marginBottom: 14 }}>{r.desc}</div>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <span style={{ fontSize: 11, color: MUTED }}>Last: {r.last}</span>
              <Btn size="sm" variant="ghost" onClick={() => alert(`Generating ${r.name}...`)}>📥 Download</Btn>
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
}

// ── NOTIFICATIONS ──────────────────────────────────────────────────────────
function Notifications() {
  const events = [
    { event: "Pickup Confirmed", desc: "When your pickup is confirmed by BRL", wa: true, email: true, sms: false },
    { event: "Shipment In Transit", desc: "When your consignment departs origin", wa: true, email: false, sms: false },
    { event: "Out for Delivery", desc: "When vehicle is 1–2 hours away", wa: true, email: false, sms: true },
    { event: "Delivered", desc: "On successful delivery with timestamp", wa: true, email: true, sms: false },
    { event: "POD Available", desc: "When POD is uploaded and downloadable", wa: false, email: true, sms: false },
    { event: "Invoice Raised", desc: "New invoice generated for your account", wa: false, email: true, sms: false },
    { event: "Payment Acknowledged", desc: "When payment is recorded in our system", wa: true, email: true, sms: false },
    { event: "Grievance Update", desc: "Activity on any of your open tickets", wa: true, email: true, sms: false },
    { event: "Delay Alert", desc: "When shipment is running behind ETA", wa: true, email: false, sms: false },
  ];
  const [prefs, setPrefs] = useState(events.reduce((a, e) => ({ ...a, [e.event]: { wa: e.wa, email: e.email, sms: e.sms } }), {}));
  const toggle = (event, channel) => setPrefs(p => ({ ...p, [event]: { ...p[event], [channel]: !p[event][channel] } }));
  const Toggle = ({ on, onClick }) => (
    <div onClick={onClick} style={{ width: 34, height: 18, background: on ? R : "#e2e8f0", borderRadius: 9, cursor: "pointer", position: "relative", transition: "background 0.2s", flexShrink: 0 }}>
      <div style={{ width: 14, height: 14, background: WHITE, borderRadius: "50%", position: "absolute", top: 2, left: on ? 18 : 2, transition: "left 0.2s", boxShadow: "0 1px 3px rgba(0,0,0,0.2)" }} />
    </div>
  );
  return (
    <div>
      <SectionTitle title="Notification Preferences" sub="Control how and when BRL contacts you" />
      <Card>
        <div style={{ display: "grid", gridTemplateColumns: "1fr auto auto auto", gap: "0 24px", alignItems: "center" }}>
          <div style={{ padding: "0 0 10px", fontSize: 11, fontWeight: 700, color: MUTED, textTransform: "uppercase", letterSpacing: 0.5 }}>Event</div>
          {["WhatsApp", "Email", "SMS"].map(c => <div key={c} style={{ padding: "0 0 10px", fontSize: 11, fontWeight: 700, color: MUTED, textTransform: "uppercase", letterSpacing: 0.5, textAlign: "center" }}>{c}</div>)}
          <div style={{ gridColumn: "1/-1", height: 1, background: BORDER, marginBottom: 14 }} />
          {events.map(e => (<>
            <div key={e.event + "label"} style={{ paddingBottom: 16 }}>
              <div style={{ fontSize: 13, fontWeight: 600, color: NAVY }}>{e.event}</div>
              <div style={{ fontSize: 11, color: MUTED }}>{e.desc}</div>
            </div>
            {["wa", "email", "sms"].map(ch => (
              <div key={e.event + ch} style={{ display: "flex", justifyContent: "center", paddingBottom: 16 }}>
                <Toggle on={prefs[e.event][ch]} onClick={() => toggle(e.event, ch)} />
              </div>
            ))}
          </>))}
        </div>
        <div style={{ borderTop: `1px solid ${BORDER}`, paddingTop: 16, display: "flex", justifyContent: "flex-end", gap: 10 }}>
          <Btn variant="secondary">Reset to Default</Btn>
          <Btn variant="primary" onClick={() => alert("Notification preferences saved!")}>Save Preferences</Btn>
        </div>
      </Card>
    </div>
  );
}

// ── UNBILLED ───────────────────────────────────────────────────────────────
function Unbilled() {
  return (
    <div>
      <SectionTitle title="Unbilled Consignments" sub="CNs awaiting invoice generation — follow up with your KAM" />
      <Card>
        <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
          <thead><tr style={{ background: "#f8fafc" }}>
            {["CN Number", "LR Number", "Route", "Booking Date", "Packages", "Weight", "Material", "Days Since Delivery", "Action"].map(h => (
              <th key={h} style={{ padding: "9px 14px", textAlign: "left", fontSize: 11, fontWeight: 700, color: MUTED, textTransform: "uppercase", letterSpacing: 0.5, borderBottom: `1px solid ${BORDER}`, whiteSpace: "nowrap" }}>{h}</th>
            ))}
          </tr></thead>
          <tbody>{UNBILLED.map(u => (
            <tr key={u.cn} onMouseEnter={e => e.currentTarget.style.background = "#fafafa"} onMouseLeave={e => e.currentTarget.style.background = ""} style={{ borderBottom: `1px solid #f8fafc` }}>
              <td style={{ padding: "11px 14px", fontFamily: "'DM Mono', monospace", fontSize: 12, fontWeight: 700, color: NAVY }}>{u.cn}</td>
              <td style={{ padding: "11px 14px", fontFamily: "'DM Mono', monospace", fontSize: 12, color: MUTED }}>{u.lr}</td>
              <td style={{ padding: "11px 14px", fontSize: 12 }}>{u.route}</td>
              <td style={{ padding: "11px 14px", fontSize: 12, fontFamily: "'DM Mono', monospace" }}>{u.date}</td>
              <td style={{ padding: "11px 14px", fontSize: 12 }}>{u.pkgs}</td>
              <td style={{ padding: "11px 14px", fontSize: 12, fontFamily: "'DM Mono', monospace" }}>{u.weight}</td>
              <td style={{ padding: "11px 14px", fontSize: 12 }}>{u.material}</td>
              <td style={{ padding: "11px 14px" }}>
                <span style={{ fontWeight: 700, fontFamily: "'DM Mono', monospace", color: u.days > 5 ? R : u.days > 2 ? AMBER : GREEN }}>{u.days}d</span>
              </td>
              <td style={{ padding: "11px 14px" }}>
                <Btn size="sm" variant="ghost" onClick={() => alert(`Following up on ${u.cn} with Mohit Pandey (KAM). You will receive a response within 24 hours.`)}>Follow Up</Btn>
              </td>
            </tr>
          ))}</tbody>
        </table>
        <div style={{ marginTop: 14, padding: "12px 16px", background: "#fef3c7", borderRadius: 10, fontSize: 13, color: "#92400e" }}>
          💡 <strong>4 CNs</strong> pending invoice. Total estimated value: ~₹3.2L. Contact your KAM {USER.kam} at {USER.kam_phone} to expedite.
        </div>
      </Card>
    </div>
  );
}

// ── MAIN PORTAL ────────────────────────────────────────────────────────────
const NAV_ITEMS = [
  { id: "dashboard", label: "Dashboard", icon: "◉", group: null },
  { id: "track", label: "Track Shipment", icon: "🔍", group: "SHIPMENTS" },
  { id: "pickup", label: "Schedule Pickup", icon: "📅", group: "SHIPMENTS" },
  { id: "rate", label: "Rate Enquiry", icon: "💰", group: "SHIPMENTS" },
  { id: "outstanding", label: "Outstanding", icon: "💳", group: "FINANCE" },
  { id: "unbilled", label: "Unbilled CNs", icon: "📄", group: "FINANCE" },
  { id: "documents", label: "Documents & POD", icon: "📥", group: "FINANCE" },
  { id: "reports", label: "MIS Reports", icon: "📊", group: "FINANCE" },
  { id: "grievances", label: "Grievances", icon: "🎫", group: "SUPPORT" },
  { id: "notifications", label: "Notifications", icon: "🔔", group: "SUPPORT" },
];

function Portal({ onLogout }) {
  const [page, setPage] = useState("dashboard");
  const groups = [...new Set(NAV_ITEMS.map(n => n.group))];

  const titles = { dashboard: "Dashboard", track: "Track Shipment", pickup: "Schedule Pickup", rate: "Rate Enquiry", outstanding: "Outstanding", unbilled: "Unbilled CNs", documents: "Documents", reports: "MIS Reports", grievances: "Grievances", notifications: "Notifications" };

  return (
    <div style={{ display: "flex", minHeight: "100vh", background: BG, fontFamily: "'Outfit', 'DM Sans', sans-serif" }}>
      {/* Sidebar */}
      <div style={{ width: 230, background: NAVY, flexShrink: 0, display: "flex", flexDirection: "column", position: "fixed", height: "100vh", overflowY: "auto" }}>
        <div style={{ padding: "20px 18px 16px", borderBottom: "1px solid rgba(255,255,255,0.07)" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 16 }}>
            <div style={{ width: 36, height: 36, background: R, borderRadius: 8, display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 900, color: WHITE, fontSize: 13, flexShrink: 0 }}>BRL</div>
            <div>
              <div style={{ color: WHITE, fontWeight: 700, fontSize: 13 }}>Best Roadways</div>
              <div style={{ color: "rgba(255,255,255,0.35)", fontSize: 10, fontFamily: "'DM Mono', monospace" }}>Customer Portal</div>
            </div>
          </div>
          <div style={{ background: "rgba(255,255,255,0.07)", borderRadius: 10, padding: "10px 12px" }}>
            <div style={{ fontSize: 13, fontWeight: 700, color: WHITE, marginBottom: 2 }}>{USER.name}</div>
            <div style={{ fontSize: 11, color: "rgba(255,255,255,0.45)" }}>{USER.company}</div>
          </div>
        </div>

        <div style={{ flex: 1, padding: "10px 0" }}>
          {groups.map(group => (
            <div key={group || "main"}>
              {group && <div style={{ padding: "12px 18px 5px", fontSize: 9, fontWeight: 700, color: "rgba(255,255,255,0.22)", textTransform: "uppercase", letterSpacing: 1.5 }}>{group}</div>}
              {NAV_ITEMS.filter(n => n.group === group).map(item => (
                <button key={item.id} onClick={() => setPage(item.id)} style={{ display: "flex", alignItems: "center", gap: 9, width: "100%", padding: "8px 18px", background: page === item.id ? "rgba(192,57,43,0.22)" : "none", border: "none", borderLeft: `3px solid ${page === item.id ? R : "transparent"}`, color: page === item.id ? WHITE : "rgba(255,255,255,0.5)", cursor: "pointer", fontSize: 13, fontWeight: page === item.id ? 600 : 400, fontFamily: "inherit", textAlign: "left", transition: "all 0.12s" }}
                  onMouseEnter={e => { if (page !== item.id) e.currentTarget.style.color = "rgba(255,255,255,0.82)"; }}
                  onMouseLeave={e => { if (page !== item.id) e.currentTarget.style.color = "rgba(255,255,255,0.5)"; }}>
                  <span style={{ fontSize: 14 }}>{item.icon}</span>{item.label}
                  {item.id === "grievances" && GRIEVANCES.filter(g => g.status !== "Resolved").length > 0 && (
                    <span style={{ marginLeft: "auto", background: R, color: WHITE, borderRadius: 99, fontSize: 10, fontWeight: 700, padding: "1px 6px" }}>{GRIEVANCES.filter(g => g.status !== "Resolved").length}</span>
                  )}
                </button>
              ))}
            </div>
          ))}
        </div>

        <div style={{ padding: "14px 18px", borderTop: "1px solid rgba(255,255,255,0.07)" }}>
          <button onClick={onLogout} style={{ background: "none", border: "none", color: "rgba(255,255,255,0.4)", cursor: "pointer", fontSize: 12, fontFamily: "inherit", display: "flex", alignItems: "center", gap: 6, width: "100%" }}>
            ← Sign Out
          </button>
        </div>
      </div>

      {/* Main */}
      <div style={{ marginLeft: 230, flex: 1, padding: "28px 32px" }}>
        {/* Top bar */}
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 24 }}>
          <h1 style={{ margin: 0, fontSize: 20, fontWeight: 800, color: NAVY }}>{titles[page]}</h1>
          <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
            <div style={{ background: WHITE, border: `1px solid ${BORDER}`, borderRadius: 8, padding: "6px 14px", fontSize: 12, color: MUTED }}>
              Mon, 6 Apr 2026
            </div>
            <div style={{ width: 36, height: 36, background: R, borderRadius: 8, display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 700, color: WHITE, fontSize: 13, cursor: "pointer" }}>
              {USER.name.split(" ").map(n => n[0]).join("")}
            </div>
          </div>
        </div>

        {page === "dashboard" && <Dashboard setPage={setPage} />}
        {page === "track" && <TrackShipment />}
        {page === "outstanding" && <Outstanding />}
        {page === "documents" && <Documents />}
        {page === "grievances" && <Grievances />}
        {page === "pickup" && <SchedulePickup />}
        {page === "rate" && <RateEnquiry />}
        {page === "reports" && <MISReports />}
        {page === "notifications" && <Notifications />}
        {page === "unbilled" && <Unbilled />}
      </div>
    </div>
  );
}

// ── ROOT ───────────────────────────────────────────────────────────────────
export default function App() {
  const [loggedIn, setLoggedIn] = useState(false);
  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Outfit:wght@400;500;600;700;800&family=DM+Mono:wght@400;500;600;700&display=swap');
        * { box-sizing: border-box; }
        body { margin: 0; }
        ::-webkit-scrollbar { width: 5px; height: 5px; }
        ::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 3px; }
        ::-webkit-scrollbar-track { background: transparent; }
        input:focus, select:focus, textarea:focus { border-color: #c0392b !important; box-shadow: 0 0 0 3px rgba(192,57,43,0.1) !important; }
      `}</style>
      {loggedIn ? <Portal onLogout={() => setLoggedIn(false)} /> : <LoginScreen onLogin={() => setLoggedIn(true)} />}
    </>
  );
}
